
import { SPORT_VOKRUG_PLUS_SUBSCRIPTION_ANCHOR } from 'constants/SUBSCRIPTION';
import { EDIT_URL_PART } from 'constants/URL';
import { urlRootPath } from 'helpers/urlPath';
import { USER_PAGE_URL_PART } from 'pages/PersonalSettingsPage/URL';
import { SPORT_URL_PART } from 'pages/Sport/_constants/SPORT_URLS';

export const getSportVokrugPlusPlansUrl = (auser_id) => (
  `${urlRootPath(SPORT_URL_PART, USER_PAGE_URL_PART, auser_id, EDIT_URL_PART)}#${SPORT_VOKRUG_PLUS_SUBSCRIPTION_ANCHOR}`
);
